import { capitalize, Stack, Typography } from '@mui/material'
import { ComponentType as ReactComponentType } from 'react'

import { PageHeader } from '@/components'
import MessageAssimilation from '@/components/CustomComponent/MessageAssimilation'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { ComponentType } from '@/utils/api'

import {
  AuthCode,
  CustomRecipe,
  DataDump,
  DataIntake,
  HomeBase,
  InlineSignup,
  Introduction,
  SemanticSearch,
  SentimentCheck,
  SimpleApiCall,
  TaskTracker,
  UserGrouping,
} from './CustomComponents'
import { useGetCustomComponent } from './hooks'

export const ComponentMapping: Record<
  ComponentType,
  ReactComponentType<any>
> = {
  [ComponentType.authCode]: AuthCode,
  [ComponentType.DataDump]: DataDump,
  [ComponentType.dataIntake]: DataIntake,
  [ComponentType.homeBase]: HomeBase,
  [ComponentType.inlineSignup]: InlineSignup,
  [ComponentType.introduction]: Introduction,
  [ComponentType.recipe]: CustomRecipe,
  [ComponentType.semanticSearch]: SemanticSearch,
  [ComponentType.sentimentCheck]: SentimentCheck,
  [ComponentType.SimpleApiCall]: SimpleApiCall,
  [ComponentType.taskTracker]: TaskTracker,
  [ComponentType.userGrouping]: UserGrouping,
  [ComponentType.messageAssimilation]: MessageAssimilation,
}

const EditComponent = () => {
  const { componentID } = useComponentProvider()
  const component = useGetCustomComponent(componentID)

  if (component.isLoading || !component.data)
    return <Typography>Loading...</Typography>

  const Component = ComponentMapping[component.data.type]
  return (
    <Stack gap={2} height="100%">
      <PageHeader
        breadcrumbs={[
          { link: '../../..', name: 'Home' },
          {
            link: '../..',
            name: component.data?.org?.name ?? 'Loading org name...',
          },
          {
            link: '..',
            name: 'Custom Components',
          },
          {
            link: `..?search=${component.data?.type}`,
            name: capitalize(
              component.data?.type ?? 'Loading Component type...'
            ),
          },
        ]}
        title={component.data?.name ?? 'Component'}
        updatedBy={component.data?.updatedBy?.name}
        updatedOn={component.data?.updatedAt}
      />
      <Stack flex={1}>
        <Component />
      </Stack>
    </Stack>
  )
}

export default EditComponent
